<template>
  <div class="px-8 pt-4 pb-2" :class="{ isEditing }">
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Rent/Mortgage"
          v-model="serviceProof.rentMortgage"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Security Deposit"
          v-model="serviceProof.securityDeposit"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
          label="Utilities"
          v-model="serviceProof.utilities"
          :rules="[validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>     
      <v-col cols="12" md="4">
        <text-field
          label="Car Assistance"
          v-model="serviceProof.carAssistance"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>      
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Transportation"
          v-model="serviceProof.transportation"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>      
      <v-col cols="12" md="4">
        <text-field
          label="Medical Expenses"
          v-model="serviceProof.medicalExpenses"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>     
     
    </v-row>
       <v-row>
      <v-col cols="12" md="4">
        <text-field
          label="Childcare"
          v-model="serviceProof.childCare"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>      
      <v-col cols="12" md="4">
        <text-field
          label="Other"
          v-model="serviceProof.other"
          :rules="[validators.required, validators.name]"
          maxlength="100"
          :readonly="readonly"
        />
      </v-col>     
     
    </v-row>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import formatters from '@/helpers/formatters'
import validators from '@/helpers/validators'
import { findValidatableElement } from '@/helpers/form'

import TextField from '@/components/form/TextField'
import SelectField from '@/components/form/SelectField'
import AdsFormatContactField from '@/components/app/AdsFormatContactField'
import MultiSelectField from '@/components/form/MultiSelectField'
import DateField from '@/components/form/DateField'
import ReadOnlyField from '@/components/form/ReadOnlyField'
import RadioOptions from '@/components/form/RadioOptions'
import { GENDER_OPTIONS,DATE_OF_BIRTH_MINIMUM_YEAR } from '@/constants'

function dateToIsoDate(date) {
  return date.toISOString ? date.toISOString().slice(0, 10) : null
}

export default {
  name: 'ServiceProofDetails',
  components: {
    TextField,
    SelectField,
    MultiSelectField,
    DateField,
    ReadOnlyField,
    RadioOptions,
    AdsFormatContactField
  },
  props: {
    readonly: {
      type: Boolean,
      defaiult: true
    }
  },
  data() {
    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

    const startOfThisYear = new Date()
    startOfThisYear.setDate(1)
    startOfThisYear.setMonth(0)

    const endOfNextYear = new Date()
    endOfNextYear.setMonth(11, 31) // zero based months!
    endOfNextYear.setFullYear(startOfThisYear.getFullYear() + 1)

    const thisYear = new Date().getFullYear()
    const minAttendedYear = thisYear -16
    const maxAttendedLastDate = `${thisYear.toString()}-12-31`

    const {
      required,
      noPastDate,
      noFutureDate,
      noFutureMonthAndYear,
      noMonthAndYearBefore16years,
      name,
      primaryClientMaxAge
    } = validators

    return {
      MONTH_YEAR_DATE_FORMAT: 'MM-YYYY',
      minBirthDate: `${thisYear - DATE_OF_BIRTH_MINIMUM_YEAR}-01-01`,
      sevenDaysAgo: dateToIsoDate(sevenDaysAgo),
      endOfNextYear: dateToIsoDate(endOfNextYear),
      boolYesNo: formatters.boolYesNo,
      validators: {
        required,
        noPastDate,
        noFutureDate,
        noFutureMonthAndYear,
        noMonthAndYearBefore16years,
        name,
        primaryClientMaxAge,
        maxStartDate: validators.getMaxFutureYearValidator(1),
        prevSchoolEndDate: toDate =>
          validators.dateOrder(
            this.previousSchool.prevSchoolStartDate,
            toDate
          ) || "Cannot be earlier than 'Attended from' date"
      },
      genderOptions: GENDER_OPTIONS,
      minAttendedStartDate: new Date(`${minAttendedYear}-01-01`).toISOString().slice(0, 10),
      maxAttendedStartDate: new Date().toISOString().slice(0, 10),
      maxAttendedLastDate
    }
  },
  computed: {
    ...mapGetters([
      'application', 
      'isEditing', 
      'referenceData'
    ]),
    serviceProof() {
      return this.application.application.supportingDocuments
    },
  },
  methods: {
    isOtherEthinicity(){
      const ethinics = this.application.application.serviceProof.ethinicity.ethinics
      if (ethinics && ethinics.find(item => item === 'OtherEthinicity')) {
        return this.application.application.serviceProof.ethinicity.find(item => item === 'otherEthinicity').length > 0
      }
    },
    crossValidate(ref) {
      const refEl = this.$refs[ref]
      // our component doesn't implement vuetify's validatable interface
      // so we have to find the validatable element in its children
      const validatableElement = findValidatableElement(refEl)
      if (validatableElement) {
        validatableElement.validate(true)
      }
    }
  }
}
</script>
